module.exports = __webpack_public_path__ + "img/bsmk3.b1e1d919.png";